import { EventEmitter } from '../utils/events.js';

/**
 * Gemeinsamer Zustand für "Zuhause": Position (lon/lat) + Alarm-Radius.
 * Wird von ui/homeMarker.js (Haus-Pin + Radius-Ring auf der Karte) und
 * ui/homeAlarm.js (Tiefflug-Erkennung) geteilt, damit beide dieselbe Quelle
 * nutzen. Persistiert in localStorage und meldet jede Änderung über 'change'.
 */

const LOCATION_KEY = 'frm-home';
const RADIUS_KEY = 'frm-home-radius-km';

export const HOME_RADIUS_MIN_KM = 1;
export const HOME_RADIUS_MAX_KM = 3;
export const HOME_RADIUS_DEFAULT_KM = 3;

export class HomeState extends EventEmitter {
  constructor() {
    super();
    this.location = this._loadLocation(); // { lon, lat } | null
    this.radiusKm = this._loadRadius();
  }

  _loadLocation() {
    try {
      const raw = localStorage.getItem(LOCATION_KEY);
      const p = raw ? JSON.parse(raw) : null;
      if (p && Number.isFinite(p.lon) && Number.isFinite(p.lat)) {
        return { lon: p.lon, lat: p.lat };
      }
    } catch { /* ignore */ }
    return null;
  }

  _loadRadius() {
    const raw = Number(localStorage.getItem(RADIUS_KEY));
    if (Number.isFinite(raw) && raw >= HOME_RADIUS_MIN_KM && raw <= HOME_RADIUS_MAX_KM) {
      return raw;
    }
    return HOME_RADIUS_DEFAULT_KM;
  }

  hasHome() {
    return Boolean(this.location);
  }

  setLocation(lon, lat) {
    this.location = { lon, lat };
    localStorage.setItem(LOCATION_KEY, JSON.stringify(this.location));
    this.emit('change', this);
  }

  clearLocation() {
    this.location = null;
    localStorage.removeItem(LOCATION_KEY);
    this.emit('change', this);
  }

  setRadiusKm(km) {
    const clamped = Math.min(HOME_RADIUS_MAX_KM, Math.max(HOME_RADIUS_MIN_KM, Number(km)));
    if (!Number.isFinite(clamped) || clamped === this.radiusKm) return;
    this.radiusKm = clamped;
    localStorage.setItem(RADIUS_KEY, String(clamped));
    this.emit('change', this);
  }
}
